import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { URLStock } from "../other/apis";
import { EndPointPatiosId } from '../Services/EndPointIngresos';
import api from "../Services/ApiURLBase";

export const StockContext = createContext();

// Custom hook to use the Stock context
export const useStock = () => {
  const context = useContext(StockContext);
  if (!context) {
    throw new Error('useStock must be used within an StockProvider');
  }
  return context;
};

// Provider component
export const StockProvider = ({ children }) => {
  const [miningSite, setMiningSite] = useState(0);
  const [warehouse, setWarehouse] = useState(0);
  const [selected, setSelected] = useState(null);
  const [stock, setStock] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const prevMiningSiteRef = useRef(miningSite);
  const isInitialRender = useRef(true);

  const fetchStock = async () => {
    try {
      const response = await api.get(
        URLStock(miningSite, warehouse)
      );
      
      setSelected(null);
      setStock(response.data.data);
    } catch (error) {
      console.error('Error fetching stock:', error);
    }
  };

  const fetchYards = async () => {
    try {
      const response = await EndPointPatiosId('0');
      const warehousesData = response.data.data || [];
      setWarehouses(warehousesData);
    } catch (error) {
      console.error('Error fetching yards:', error);
    }
  };

  useEffect(() => {
    fetchYards();
    fetchStock();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    const miningSiteChanged = prevMiningSiteRef.current !== miningSite;
  
    if (miningSiteChanged) {
      prevMiningSiteRef.current = miningSite;
      if (warehouse !== 0) {
        setWarehouse(0);
        return;
      }
    }
    
    fetchStock();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [miningSite, warehouse]);

  const contextValue = {
    miningSite,
    warehouse,
    warehouses,
    selected,
    stock,
    setStock,
    setSelected,
    setMiningSite,
    setWarehouse,
  };

  return (
    <StockContext.Provider value={contextValue}>
      {children}
    </StockContext.Provider>
  );
}